import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.582 9.617c-.491 0-.944.173-1.299.46L5.715 7.496c.06-.328.06-.664 0-.992l3.568-2.581a2.068 2.068 0 0 0 3.365-1.607c0-1.14-.926-2.066-2.066-2.066a2.068 2.068 0 0 0-1.986 2.64L5.207 5.343a2.754 2.754 0 1 0-2.202 4.412c.9 0 1.7-.432 2.202-1.098l3.39 2.453q-.082.276-.082.574c0 1.14.927 2.066 2.067 2.066s2.066-.926 2.066-2.066-.926-2.067-2.066-2.067m0-8.196a.896.896 0 1 1-.001 1.792.896.896 0 0 1 0-1.792M3.005 8.515C2.17 8.515 1.49 7.835 1.49 7s.68-1.515 1.515-1.515S4.52 6.165 4.52 7s-.68 1.515-1.515 1.515m7.577 4.064a.896.896 0 1 1 0-1.791.896.896 0 0 1 0 1.791"
    }, null, -1)
  ])))
}
export default { render: render }